// used for Shopping Experience
import PiggyBank from 'static/images/studio/product-details/im-savings@2x.svg';
import Shopper from 'static/images/studio/product-details/im-shopper@2x.svg';
import Checkout from 'static/images/studio/product-details/im-checkout@2x.svg';

export const PRICE_MATCH_TEXT_V0 = `
  After checkout, we'll confirm if there's a lower price available,
  including any retailer sales and promotions. If you find a better
  advertised price with one of our retail partners, we'll match it.
`;

export const PRICE_MATCH_TEXT_V1_PART1 = `
  You'll pay less if you buy through Modsy! Found a better price on
  our retailer's site? See a sale not yet reflected on Modsy?
`;

export const PRICE_MATCH_TEXT_V1_PART2 = `
  We'll match the seller's lowest advertised price AND we'll give
  you our own discounts on top of it.
`;

export const RETURN_POLICY = `
  Item ships directly from the retailer based on availability
  on retailer's site. Modsy will adjust both the item price
  and shipping cost to match the retailer price, including
  honoring advertised sales and promotions on the day order
  is placed. Returns and exchanges can be made in accordance
  with each retailer's policy.
`;

export const FILTERS_DISPLAY_VALUES = [
  'Brand',
  'Price',
  'Height',
  'Width',
  'Depth',
  'Material',
  'Color'
];

export const RANGED_FILTERS = [
  'price',
  'height',
  'depth',
  'width'
];

export const FILTER_OPTION_NAMES_MAP = {
  brand: 'retailer',
  price: 'priceRange',
  height: 'heightRange',
  depth: 'depthRange',
  width: 'widthRange',
  color: 'colors',
  material: 'materials'
};

export const SEARCH_FILTERS_MAP = {
  brand: 'retailer',
  price: 'priceRange',
  width: 'width',
  height: 'height',
  depth: 'depth',
  color: 'colors',
  material: 'materials'
};

export const SHOPPING_EXPERIENCE_SECTIONS = [
  {
    name: 'save-info',
    header: 'Modsy Membership',
    subHeader:
      'Access to exclusive discounts and shopping perks.',
    image: PiggyBank,
    imageWidth: {
      large: 88,
      small: 50
    }
  },
  {
    header: 'Personal shopper team',
    subHeader: `
      We’ll place all orders on your behalf directly with retailers!
    `,
    image: Shopper,
    imageWidth: {
      large: 104,
      small: 60
    }
  },
  {
    header: 'One Stop Shop',
    subHeader:
      "We'll coordinate shipping, delivery, returns and exchanges.",
    image: Checkout,
    imageWidth: {
      large: 176,
      small: 105
    }
  }
];
